/*
 * @Author: etong
 * @Date: 2021-07-16 14:55:54
 * @LastEditTime: 2021-07-16 16:28:35
 * @LastEditors: your name
 * @Description:
 * @FilePath: \oak\src\directive\preventReClick\preventReClick.js
 * Think first, Program later
 */
export default {
  bind(el, binding) {
    el.addEventListener('click', e => {
      if (!el.disabled) {
        el.disabled = true

        let timer = null;
        (() => {
          if (timer) {
            clearTimeout(timer)
          }
          timer = setTimeout(() => {
            el.disabled = false
          }, binding.value || 300)
        })()
      }
    })
  }
}
